import React from "react";
import { Link } from "react-router-dom";

const Forbidden: React.FC = () => {
  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center text-center">
      <h1 className="text-3xl font-semibold text-slate-900 dark:text-white">403 — Access Denied</h1>
      <p className="mt-3 max-w-md text-sm text-slate-600 dark:text-slate-400">
        This module or feature is not enabled for your organization. Contact your administrator if
        you believe this is an error.
      </p>
      <Link
        to="/"
        className="mt-6 rounded-lg bg-amber-500 px-4 py-2 text-sm font-medium text-black hover:bg-amber-400"
      >
        Go to Dashboard
      </Link>
    </div>
  );
};

export default Forbidden;
